import {IS_SERVER} from "../../common";

export const translation = {
  zenit: {
    ae: {
      siteTitle: "المراهنات الرياضية | Zenit",
      btnLogin: "تسجيل الدخول",
      btnSignup: "سجّل",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `جرب حظك
          مع Zenit وكيل المراهنات`
        : `جرب 
          حظك
          مع Zenit وكيل المراهنات`),
      stepTitle1: "سجّل",
      stepSubtitle1: "أنشئ حسابًا في \n" +
        " بضع دقائق",
      stepTitle2: "أودع",
      stepSubtitle2: "أودع باستخدام \n" +
        "  أي وسيلة متاحة",
      stepTitle3: "فز",
      stepSubtitle3: "اختر الأحداث وراهن واكسب",
      productTitle1: "المراهنات الرياضية",
      productDescription1: `راهن على الرياضات 
        والرياضات الإلكترونية والمزيد`,
      productTitle2: "كازينو",
      productDescription2: `جرب حظك
        ي ألعاب الكازينو وألعاب الحظ`,
      productTitle3: "كازينو مباشر",
      productDescription3: `العب على الإنترنت
        مع موزعين حقيقيين`,
      productTitle4: "Betgames",
      productDescription4: `راهن على 
        لألعاب الافتراضية`,
      productTitle5: "توتو",
      productDescription5: `خمن كل النتائ
        وفز بالجائزة الكبرى`,
      bkString: 'Zenit المراهنات',
      rightString: 'جميع الحقوق محفوظة',
    },
    bn: {
      siteTitle: "ক্রীড়া বাজি | Zenit",
      btnLogin: "সাইন ইন করুন",
      btnSignup: "নিবন্ধন করুন",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `বুকমেকার Zenit-এর সাথে 
          আপনার ভাগ্য পরীক্ষা করুন`
        : `বুকমেকার Zenit-এর সাথে 
          আপনার ভাগ্য
          পরীক্ষা করুন`),
      stepTitle1: "নিবন্ধন করুন",
      stepSubtitle1: "কয়েক মিনিটে অ্যাকাউন্ট তৈরি করুন।",
      stepTitle2: "জমা করুন",
      stepSubtitle2: "যেকোনো উপলভ্য পদ্ধতি ব্যবহার করে  জমা করুন।",
      stepTitle3: "জয় পান",
      stepSubtitle3: "ইভেন্টগুলি বেছে নিন, বাজি ধরুন এবং জিতুন!",
      productTitle1: "ক্রীড়া বাজি",
      productDescription1: `স্পোর্টস, ই-স্পোর্টস 
        এবং আরও অনেক কিছুর উপর বাজি ধরুন`,
      productTitle2: "ক্যাসিনো",
      productDescription2: `ক্যাসিনো গেমস এবং স্লট 
        দিয়ে আপনার ভাগ্য পরীক্ষা করুন`,
      productTitle3: "লাইভ ক্যাসিনো",
      productDescription3: `আসল ডিলারদের সাথে 
        অনলাইনে খেলুন`,
      productTitle4: "Betgames",
      productDescription4: `ভার্চুয়াল
        গেমগুলোর উপর বাজি ধরুন`,
      productTitle5: "Toto",
      productDescription5: `সকল ফলাফল অনুমান করুন 
        এবং জ্যাকপট জিতে নিন`,
      bkString: ' বুকমেকার Zenit',
      rightString: 'সর্বস্বত্ব সংরক্ষিত',
    },
    br: {
      siteTitle: "Apostas esportivas | Bookmaker Zenit",
      btnLogin: "LOGIN",
      btnSignup: "REGISTRE-SE",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Tentesua sorte
          com a casa de apostas Zenit`
        : `Tente
          sua sorte
          com a casa de apostas Zenit`),
      stepTitle1: "Registre-se",
      stepSubtitle1: "Crie uma conta em alguns minutos.",
      stepTitle2: "Faça depósitos",
      stepSubtitle2: "Faça um depósito usando qualquer método disponível.",
      stepTitle3: "Vença",
      stepSubtitle3: "Escolha eventos, faça apostas e ganhe!",
      productTitle1: "Apostas esportivas",
      productDescription1: `Faça apostas em esportes, esports
        e muito mais`,
      productTitle2: "Cassino",
      productDescription2: `Tente sua sorte
        em jogos de cassino e caça-níqueis`,
      productTitle3: "Cassino ao vivo",
      productDescription3: `Jogue online 
        com crupiês reais`,
      productTitle4: "Betgames",
      productDescription4: `Faça apostas em
        jogos virtuais`,
      productTitle5: "Toto",
      productDescription5: `Adivinhe todos os 
        resultados e acerte o jackpot`,
      bkString: 'Casa de Apostas Zenit',
      rightString: 'Todos os direitos reservados',
    },
    de: {
      siteTitle: "Sportwetten | Zenit",
      btnLogin: "ANMELDEN",
      btnSignup: "REGISTRIEREN",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Versuchen Sie Ihr Glück
          mit Bookmaker Zenit`
        : `Versuchen Sie
          Ihr Glück
          mit Bookmaker Zenit`),
      stepTitle1: "Registrieren",
      stepSubtitle1: "Erstellen Sie in wenigen Minuten ein Konto.",
      stepTitle2: "Einzahlen",
      stepSubtitle2: "Tätigen Sie eine Einzahlung mit einer der verfügbaren Methoden.",
      stepTitle3: "Gewinnen",
      stepSubtitle3: "Ereignisse auswählen, Wetten abschließen und gewinnen!",
      productTitle1: "Sportwetten",
      productDescription1: `Wetten auf Sport, 
        Esports und mehr`,
      productTitle2: "Casino",
      productDescription2: `Versuchen Sie Ihr Glück
        bei Casinospielen und Spielautomaten`,
      productTitle3: "Live-Casino",
      productDescription3: `Spielen Sie online
        mit echten Dealern`,
      productTitle4: "Betgames",
      productDescription4: `Wetten Sie auf
        virtuelle Spiele`,
      productTitle5: "Toto",
      productDescription5: `Erraten Sie alles
        und gewinnen Sie den Jackpot`,
      bkString: ' Buchmacher Zenit',
      rightString: ' Alle Rechte vorbehalten',
    },
    en: {
      siteTitle: "Sports betting | Zenit",
      btnLogin: "SIGN IN",
      btnSignup: "REGISTER",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Try your luck
          with Bookmaker Zenit`
        : `Try your luck 
          with Bookmaker Zenit`),
      stepTitle1: "Register",
      stepSubtitle1: "Create an account in a few minutes.",
      stepTitle2: "Make deposits",
      stepSubtitle2: "Make a deposit using any available method.",
      stepTitle3: "Win",
      stepSubtitle3: "Choose events, make bets and win!",
      productTitle1: "Sports betting",
      productDescription1: `Make bets on sports, esports and more`,
      productTitle2: "Casino",
      productDescription2: `Try your luck 
        at casino games and slots`,
      productTitle3: "Live casino",
      productDescription3: `Play online
        with real dealers`,
      productTitle4: "Betgames",
      productDescription4: `Make bets on
        virtual games`,
      productTitle5: "Toto",
      productDescription5: `Guess all outcomes
        and hit the jackpot`,
      bkString: 'Bookmaker Zenit',
      rightString: 'All rights reserved',
    },
    fr: {
      siteTitle: "Paris sportifs | Zenit",
      btnLogin: "SE CONNECTER",
      btnSignup: "S'ENREGISTRER",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Tentez votre chance
          avec Bookmaker Zenit`
        : `Tentez votre chance 
          avec Bookmaker Zenit`),
      stepTitle1: "S'enregistrer",
      stepSubtitle1: "Créez un compte en quelques minutes.",
      stepTitle2: "Effectuer des dépôts",
      stepSubtitle2: "Effectuez un dépôt à l'aide de l'un des modes de dépôt disponibles.",
      stepTitle3: "Gagner",
      stepSubtitle3: "Choisissez des événements, pariez et gagnez!",
      productTitle1: "Paris sportifs",
      productDescription1: `Pariez sur des sports, 
        des eSports, etc.`,
      productTitle2: "Casino",
      productDescription2: `Tentez votre chance
        dans les jeux de casino et les machines à sous`,
      productTitle3: "Casino en direct",
      productDescription3: `Jouez en ligne
        avec de véritables croupiers`,
      productTitle4: "Betgames",
      productDescription4: `Placez des paris sur
        des jeux virtuels`,
      productTitle5: "Toto",
      productDescription5: `Pronostiquez tous les résultats
        et gagnez le jackpot`,
      bkString: 'Bookmaker Zenit',
      rightString: 'Tous droits réservés',
    },
    ir: {
      siteTitle: "شرط‌بندی ورزشی | بنگاه شرط‌بندی ZENIT",
      btnLogin: "لاگین",
      btnSignup: "ثبت‌نام",
      title: `               شانس‌تان را
        با بنگاه شرط‌بندی Zenit امتحان کنید`,
      stepTitle1: "ثبت‌نام",
      stepSubtitle1: "در چند دقیقه یک حساب کاربری ایجاد کنید",
      stepTitle2: "واریز",
      stepSubtitle2: "از هر روش ممکنی واریز کنید.",
      stepTitle3: "ببرید",
      stepSubtitle3: "رویداد انتخاب کنید، شرط ببندید و ببرید!",
      productTitle1: "شرط‌بندی ورزشی",
      productDescription1: `شرط‌بندی روی ورزش‌‌های عادی و الکترونیکی و غیره`,
      productTitle2: "کازینو",
      productDescription2: `شانس‌تان را در بازی‌های کازینویی و اسلات امتحان کنید`,
      productTitle3: "کازینو زنده",
      productDescription3: `با کارت‌پخش‌کن واقعی آنلاین بازی کنید`,
      productTitle4: "Betgames",
      productDescription4: `شرط‌بندی در بازی‌های مجازی`,
      productTitle5: "Toto",
      productDescription5: `تمامی نتایج را درست پیش‌بینی کنید و جکپات را ببرید`,
      bkString: "بنگاه شرط‌بندی Zenit",
      rightString: "تمامی حقوق محفوظ است"
    },
    kz: {
      siteTitle: "Ставки на спорт | Букмекер ZENIT",
      btnLogin: "Войти",
      btnSignup: "Зарегистрироваться",
      title: `Испытай свою удачу
        в БК Зенит`,
      stepTitle1: "Зарегистрируйся",
      stepSubtitle1: "Создай аккаунт всего за несколько минут.",
      stepTitle2: "Пополни счет",
      stepSubtitle2: "Внеси средства на баланс любым удобным способом.",
      stepTitle3: "Побеждай",
      stepSubtitle3: "Выбирай игры, делай ставки и выигрывай!",
      productTitle1: "Ставки на спорт",
      productDescription1: `Ставь на спорт, киберспорт
        или другие события`,
      productTitle2: "Казино",
      productDescription2: `Испытай удачу 
        в играх казино и слотах`,
      productTitle3: "Лайв-казино",
      productDescription3: `Играй онлайн 
        с живыми дилерами`,
      productTitle4: "Betgames",
      productDescription4: `Делай ставки на события
        в виртуальных играх`,
      productTitle5: "Тотализатор",
      productDescription5: `Угадай все исходы
        и сорви джекпот`,
      bkString: 'Букмекерская контора Зенит',
      rightString: 'Все права защищены',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    mx: {
      siteTitle: "Apuesta deportiva | Zenit",
      btnLogin: "INICIAR SESIÓN",
      btnSignup: "REGISTRAR",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Pruebesu suerte
          con Zenit Bookmaker`
        : `Pruebe
          su suerte
          con Zenit Bookmaker`),
      stepTitle1: "Registrar",
      stepSubtitle1: "Cree una cuenta en unos minutos.",
      stepTitle2: "Hacer depósitos",
      stepSubtitle2: "Haga un depósito utilizando cualquier método disponible.",
      stepTitle3: "Gane",
      stepSubtitle3: "Elija los eventos, haga sus apuestas ¡y gane!",
      productTitle1: "Apuesta deportiva",
      productDescription1: `Apuesta en deportes,  
        deportes electrónicos y más`,
      productTitle2: "Casino",
      productDescription2: `Pruebe su suerte
        en los juegos de casino y los tragamonedas`,
      productTitle3: "Casino en vivo",
      productDescription3: `Juegue en línea
        con dealers reales`,
      productTitle4: "Betgames",
      productDescription4: `Haga apuestas en
        juegos virtuales`,
      productTitle5: "Toto",
      productDescription5: `Adivine todos los resultados
        y gane el premio mayor`,
      bkString: 'Zenit Bookmakers',
      rightString: 'Todos los derechos reservados',
    },
    ru: {
      siteTitle: "Ставки на спорт | Казино | Тото | ZENIT",
      btnLogin: "Войти",
      btnSignup: "Зарегистрироваться",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Испытай свою удачу
          в БК Зенит`
        : `Испытай
          свою удачу
          в БК Зенит`),
      stepTitle1: "Зарегистрируйся",
      stepSubtitle1: "Создай аккаунт всего за несколько минут.",
      stepTitle2: "Пополни счет",
      stepSubtitle2: "Внеси средства на баланс любым удобным способом.",
      stepTitle3: "Побеждай",
      stepSubtitle3: "Выбирай игры, делай ставки и выигрывай!",
      productTitle1: "Ставки на спорт",
      productDescription1: `Ставь на спорт, киберспорт
        или другие события`,
      productTitle2: "Казино",
      productDescription2: `Испытай удачу 
        в играх казино и слотах`,
      productTitle3: "Лайв-казино",
      productDescription3: `Играй онлайн 
        с живыми дилерами`,
      productTitle4: "Betgames",
      productDescription4: `Делай ставки на события
        в виртуальных играх`,
      productTitle5: "Тотализатор",
      productDescription5: `Угадай все исходы
        и сорви джекпот`,
      bkString: 'Букмекерская контора «Зенит»',
      rightString: 'Все права защищены',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    sw: {
      siteTitle: "Kuwekeza dau za michezo | Zenit",
      btnLogin: "WEKA JINA LA MTUMIAJI",
      btnSignup: "JISAJILI",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Jaribu bahati yako
          na Alamisho Zenit`
        : `Jaribu
          bahati yako
          na Alamisho Zenit`),
      stepTitle1: "Jisajili",
      stepSubtitle1: "Fanyiza akaunti kwa dakika chache.",
      stepTitle2: "Weka pesa",
      stepSubtitle2: "Weka pesa kupitia njia yoyote inayopatikana.",
      stepTitle3: "Shida",
      stepSubtitle3: "Chagua matukio, wekeza dau na ushinde!",
      productTitle1: "Kuwekeza dau za michezo",
      productDescription1: `Wekeza dau za michezo, esports
        na nyinginezo`,
      productTitle2: "Kasino",
      productDescription2: `Jaribu bahati yako
        kwenye michezo ya kasino na vitengo`,
      productTitle3: "Kasino ya moja kwa moja",
      productDescription3: `Cheza mtandaoni
        na wachezaji halisi`,
      productTitle4: "Betgames",
      productDescription4: `Wekeza dau kwa
        michezo ya mitandaoni`,
      productTitle5: "Toto",
      productDescription5: `Bashiri matokeo yote
        na upate ushindi mkuu`,
      bkString: 'Alamisho Zenit',
      rightString: 'Haki zote zimehifadhiwa',
    },
    tr: {
      siteTitle: "Spor bahisleri | Zenit",
      btnLogin: "OTURUM AÇ",
      btnSignup: "KAYDOLUN",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Zenit Bahis Şirketi ile
          şansınızı deneyin`
        : `Zenit Bahis Şirketi 
          ile şansınızı deneyin`),
      stepTitle1: "Kaydolun",
      stepSubtitle1: "Birkaç dakika içinde bir hesap oluşturun.",
      stepTitle2: "Para yatırın",
      stepSubtitle2: "Herhangi bir yöntemi kullanarak para yatırın.",
      stepTitle3: "Galibiyet",
      stepSubtitle3: "Etkinlikleri seçin, bahis oynayın ve kazanın!",
      productTitle1: "Spor bahisleri",
      productDescription1: `Spor, e-spor ve daha 
        fazlası için bahis oynayın`,
      productTitle2: "Gazino",
      productDescription2: `Kumarhane oyunlarında
        ve slot makinelerinde şansınızı deneyin`,
      productTitle3: "Canlı kumarhane",
      productDescription3: `Gerçek krupiyelerle
        çevrimiçi oynayın`,
      productTitle4: "Betgames",
      productDescription4: `Sanal oyunlara
        bahis oynayın`,
      productTitle5: "Toto",
      productDescription5: `Tüm sonuçları tahmin
        edin ve turnayı gözünden vurun`,
      bkString: 'Zenit Bahis Şirketi',
      rightString: 'Tüm hakları saklıdır',
    },
    uz: {
      siteTitle: "Sportga stavkalar | Zenit bukmekerlik kontorasi",
      btnLogin: "KIRISH",
      btnSignup: "RO‘YXATDAN O‘T",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Zenit BK da 
          o‘z omadingni sinab ko‘r`
        : `Zenit BK da 
          o‘z omadingni
          sinab ko‘r`),
      stepTitle1: "Ro‘yxatdan o‘t",
      stepSubtitle1: "Atigi bir necha daqiqa ichida akkaunt yarat.",
      stepTitle2: "Hisobni to‘ldir",
      stepSubtitle2: "Balansga mablag‘larni istalgan usul bilan kirit.",
      stepTitle3: "G‘alaba qil",
      stepSubtitle3: "O‘yinlarni yut, stavkalar qil va yutib ol!",
      productTitle1: "Sportga stavkalar",
      productDescription1: `Sport, kibersport
        yoki boshqa hodisaga tik`,
      productTitle2: "Kazino",
      productDescription2: `Kazino o‘yinlari va slotlarda
        omadingni sinab ko‘r`,
      productTitle3: "Layv-kazino",
      productDescription3: `Jonli dilerlar bilan
        onlayn o‘yna`,
      productTitle4: "Betgames",
      productDescription4: `Virtual o‘yinlarda 
        hodisalarga stavkalar qil`,
      productTitle5: "Totalizator",
      productDescription5: `Barcha natijalarni to‘g‘ri 
        top va jekpotni yutib ol`,
      bkString: ' Zenit bukmekerlik kontorasi',
      rightString: 'Barcha huquqlar himoya qilinadi',
    },
    vi: {
      siteTitle: "Cá cược thể thao | Zenit",
      btnLogin: "ĐĂNG NHẬP",
      btnSignup: "ĐĂNG KÝ",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Thử vận may của bạn
          với nhà cái Zenit`
        : `Thử
          vận may của bạn
          với nhà cái Zenit`),
      stepTitle1: "Đăng ký",
      stepSubtitle1: "Tạo tài khoản trong một vài phút.",
      stepTitle2: "Nạp tiền",
      stepSubtitle2: "Nạp tiền bằng bất kỳ phương thức nào có sẵn.",
      stepTitle3: "Chiến thắng",
      stepSubtitle3: "Chọn sự kiện, đặt cược và giành chiến thắng!",
      productTitle1: "Cá cược thể thao",
      productDescription1: `Đặt cược vào thể thao,  
        thể thao điện tử và hơn thế nữa`,
      productTitle2: "Casino",
      productDescription2: `Thử vận may của bạn tại 
        các trò chơi casino và máy đánh bạc`,
      productTitle3: "Casino trực tuyến",
      productDescription3: `Chơi trực tuyến với
        những người chia bài thực`,
      productTitle4: "Betgames",
      productDescription4: `Đặt cược vào các
        trò chơi trực tuyến`,
      productTitle5: "Toto",
      productDescription5: `Đoán tất cả các kết quả
        và trúng giải độc đắc`,
      bkString: 'Nhà cái Zenit',
      rightString: ' Bảo lưu mọi quyền',
    },
  },
  zenbet: {
    ae: {
      siteTitle: "المراهنات الرياضية | «ZENBET»",
      btnLogin: "تسجيل الدخول",
      btnSignup: "سجّل",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `جرب حظك
          مع «ZENBET» وكيل المراهنات`
        : `جرب 
          حظك
          مع «ZENBET» وكيل المراهنات`),
      stepTitle1: "سجّل",
      stepSubtitle1: "أنشئ حسابًا في \n" +
        " بضع دقائق",
      stepTitle2: "أودع",
      stepSubtitle2: "أودع باستخدام \n" +
        "  أي وسيلة متاحة",
      stepTitle3: "فز",
      stepSubtitle3: "اختر الأحداث وراهن واكسب",
      productTitle1: "المراهنات الرياضية",
      productDescription1: `راهن على الرياضات 
        والرياضات الإلكترونية والمزيد`,
      productTitle2: "كازينو",
      productDescription2: `جرب حظك
        ي ألعاب الكازينو وألعاب الحظ`,
      productTitle3: "كازينو مباشر",
      productDescription3: `العب على الإنترنت
        مع موزعين حقيقيين`,
      productTitle4: "Betgames",
      productDescription4: `راهن على 
        لألعاب الافتراضية`,
      productTitle5: "توتو",
      productDescription5: `خمن كل النتائ
        وفز بالجائزة الكبرى`,
      bkString: '«ZENBET» المراهنات',
      rightString: 'جميع الحقوق محفوظة',
    },
    bn: {
      siteTitle: "ক্রীড়া বাজি | «ZENBET»",
      btnLogin: "সাইন ইন করুন",
      btnSignup: "নিবন্ধন করুন",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `বুকমেকার «ZENBET»-এর সাথে 
          আপনার ভাগ্য পরীক্ষা করুন`
        : `বুকমেকার «ZENBET»-এর সাথে 
          আপনার ভাগ্য
          পরীক্ষা করুন`),
      stepTitle1: "নিবন্ধন করুন",
      stepSubtitle1: "কয়েক মিনিটে  অ্যাকাউন্ট তৈরি করুন।",
      stepTitle2: "জমা করুন",
      stepSubtitle2: "যেকোনো উপলভ্য পদ্ধতি ব্যবহার করে  জমা করুন।",
      stepTitle3: "জয় পান",
      stepSubtitle3: "ইভেন্টগুলি বেছে নিন, বাজি ধরুন এবং জিতুন!",
      productTitle1: "ক্রীড়া বাজি",
      productDescription1: `স্পোর্টস, ই-স্পোর্টস 
        এবং আরও অনেক কিছুর উপর বাজি ধরুন`,
      productTitle2: "ক্যাসিনো",
      productDescription2: `ক্যাসিনো গেমস এবং স্লট 
        দিয়ে আপনার ভাগ্য পরীক্ষা করুন`,
      productTitle3: "লাইভ ক্যাসিনো",
      productDescription3: `আসল ডিলারদের সাথে 
        অনলাইনে খেলুন`,
      productTitle4: "Betgames",
      productDescription4: `ভার্চুয়াল
        গেমগুলোর উপর বাজি ধরুন`,
      productTitle5: "Toto",
      productDescription5: `সকল ফলাফল অনুমান করুন 
        এবং জ্যাকপট জিতে নিন`,
      bkString: ' বুকমেকার «ZENBET»',
      rightString: ' সর্বস্বত্ব সংরক্ষিত',
    },
    br: {
      siteTitle: "Apostas esportivas | Bookmaker «ZENBET»",
      btnLogin: "LOGIN",
      btnSignup: "REGISTRE-SE",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Tentesua sorte
          com a casa de apostas «ZENBET»`
        : `Tente
          sua sorte
          com a casa de apostas «ZENBET»`),
      stepTitle1: "Registre-se",
      stepSubtitle1: "Crie uma conta em alguns minutos.",
      stepTitle2: "Faça depósitos",
      stepSubtitle2: "Faça um depósito usando qualquer método disponível.",
      stepTitle3: "Vença",
      stepSubtitle3: "Escolha eventos, faça apostas e ganhe!",
      productTitle1: "Apostas esportivas",
      productDescription1: `Faça apostas em esportes, esports
        e muito mais`,
      productTitle2: "Cassino",
      productDescription2: `Tente sua sorte
        em jogos de cassino e caça-níqueis`,
      productTitle3: "Cassino ao vivo",
      productDescription3: `Jogue online 
        com crupiês reais`,
      productTitle4: "Betgames",
      productDescription4: `Faça apostas em
        jogos virtuais`,
      productTitle5: "Toto",
      productDescription5: `Adivinhe todos os 
        resultados e acerte o jackpot`,
      bkString: 'Casa de Apostas «ZENBET»',
      rightString: 'Todos os direitos reservados',
      regFormTitle: `REGISTRE-SE
        E OBTENHA UM BÔNUS!`
    },
    de: {
      siteTitle: "Sportwetten | «ZENBET»",
      btnLogin: "ANMELDEN",
      btnSignup: "REGISTRIEREN",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Versuchen Sie Ihr Glück
          mit Bookmaker «ZENBET»`
        : `Versuchen Sie
          Ihr Glück
          mit Bookmaker «ZENBET»`),
      stepTitle1: "Registrieren",
      stepSubtitle1: "Erstellen Sie in wenigen Minuten ein Konto.",
      stepTitle2: "Einzahlen",
      stepSubtitle2: "Tätigen Sie eine Einzahlung mit einer der verfügbaren Methoden.",
      stepTitle3: "Gewinnen",
      stepSubtitle3: "Ereignisse auswählen, Wetten abschließen und gewinnen!",
      productTitle1: "Sportwetten",
      productDescription1: `Wetten auf Sport, 
        Esports und mehr`,
      productTitle2: "Casino",
      productDescription2: `Versuchen Sie Ihr Glück
        bei Casinospielen und Spielautomaten`,
      productTitle3: "Live-Casino",
      productDescription3: `Spielen Sie online
        mit echten Dealern`,
      productTitle4: "Betgames",
      productDescription4: `Wetten Sie auf
        virtuelle Spiele`,
      productTitle5: "Toto",
      productDescription5: `Erraten Sie alles
        und gewinnen Sie den Jackpot`,
      bkString: 'Buchmacher «ZENBET»',
      rightString: 'Alle Rechte vorbehalten',
    },
    en: {
      siteTitle: "Sports betting | «ZENBET»",
      btnLogin: "SIGN IN",
      btnSignup: "REGISTER",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Try your luck
          with Bookmaker «ZENBET»`
        : `Try your luck 
          with Bookmaker «ZENBET»`),
      stepTitle1: "Register",
      stepSubtitle1: "Create an account in a few minutes.",
      stepTitle2: "Make deposits",
      stepSubtitle2: "Make a deposit using any available method.",
      stepTitle3: "Win",
      stepSubtitle3: "Choose events, make bets and win!",
      productTitle1: "Sports betting",
      productDescription1: `Make bets on sports, esports and more`,
      productTitle2: "Casino",
      productDescription2: `Try your luck at casino games and slots`,
      productTitle3: "Live casino",
      productDescription3: `Play online
        with real dealers`,
      productTitle4: "Betgames",
      productDescription4: `Make bets on
        virtual games`,
      productTitle5: "Toto",
      productDescription5: `Guess all outcomes
        and hit the jackpot`,
      bkString: 'Bookmaker «ZENBET»',
      rightString: 'All rights reserved',
    },
    fr: {
      siteTitle: "Paris sportifs | «ZENBET»",
      btnLogin: "SE CONNECTER",
      btnSignup: "S'ENREGISTRER",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Tentez votre chance
          avec Bookmaker «ZENBET»`
        : `Tentez
          votre chance
          avec Bookmaker «ZENBET»`),
      stepTitle1: "S'enregistrer",
      stepSubtitle1: "Créez un compte en quelques minutes.",
      stepTitle2: "Effectuer des dépôts",
      stepSubtitle2: "Effectuez un dépôt à l'aide de l'un des modes de dépôt disponibles.",
      stepTitle3: "Gagner",
      stepSubtitle3: "Choisissez des événements, pariez et gagnez!",
      productTitle1: "Paris sportifs",
      productDescription1: `Pariez sur des sports, 
        des eSports, etc.`,
      productTitle2: "Casino",
      productDescription2: `Tentez votre chance
        dans les jeux de casino et les machines à sous`,
      productTitle3: "Casino en direct",
      productDescription3: `Jouez en ligne
        avec de véritables croupiers`,
      productTitle4: "Betgames",
      productDescription4: `Placez des paris sur
        des jeux virtuels`,
      productTitle5: "Toto",
      productDescription5: `Pronostiquez tous les résultats
        et gagnez le jackpot`,
      bkString: 'Bookmaker «ZENBET»',
      rightString: 'Tous droits réservés',
    },
    ir: {
      siteTitle: "شرط‌بندی ورزشی | بنگاه شرط‌بندی «ZENBET»",
      btnLogin: "لاگین",
      btnSignup: "ثبت‌نام",
      title: `               شانس‌تان را
        با بنگاه شرط‌بندی «ZENBET» امتحان کنید`,
      stepTitle1: "ثبت‌نام",
      stepSubtitle1: "در چند دقیقه یک حساب کاربری ایجاد کنید",
      stepTitle2: "واریز",
      stepSubtitle2: "از هر روش ممکنی واریز کنید.",
      stepTitle3: "ببرید",
      stepSubtitle3: "رویداد انتخاب کنید، شرط ببندید و ببرید!",
      productTitle1: "شرط‌بندی ورزشی",
      productDescription1: `شرط‌بندی روی ورزش‌‌های عادی و الکترونیکی و غیره`,
      productTitle2: "کازینو",
      productDescription2: `شانس‌تان را در بازی‌های کازینویی و اسلات امتحان کنید`,
      productTitle3: "کازینو زنده",
      productDescription3: `با کارت‌پخش‌کن واقعی آنلاین بازی کنید`,
      productTitle4: "Betgames",
      productDescription4: `شرط‌بندی در بازی‌های مجازی`,
      productTitle5: "Toto",
      productDescription5: `تمامی نتایج را درست پیش‌بینی کنید و جکپات را ببرید`,
      bkString: "بنگاه شرط‌بندی «ZENBET»",
      rightString: "تمامی حقوق محفوظ است"
    },
    kz: {
      siteTitle: "Спортқа бәс тігу | «ZENBET» букмекерлік кеңсесі",
      btnLogin: "Войти",
      btnSignup: "Зарегистрироваться",
      title: `Испытай свою удачу
        в БК «ZENBET»`,
      stepTitle1: "Зарегистрируйся",
      stepSubtitle1: "Создай аккаунт всего за несколько минут.",
      stepTitle2: "Пополни счет",
      stepSubtitle2: "Внеси средства на баланс любым удобным способом.",
      stepTitle3: "Побеждай",
      stepSubtitle3: "Выбирай игры, делай ставки и выигрывай!",
      productTitle1: "Ставки на спорт",
      productDescription1: `Ставь на спорт, киберспорт
        или другие события`,
      productTitle2: "Казино",
      productDescription2: `Испытай удачу 
        в играх казино и слотах`,
      productTitle3: "Лайв-казино",
      productDescription3: `Играй онлайн 
        с живыми дилерами`,
      productTitle4: "Betgames",
      productDescription4: `Делай ставки на события
        в виртуальных играх`,
      productTitle5: "Тотализатор",
      productDescription5: `Угадай все исходы
        и сорви джекпот`,
      bkString: 'Букмекерская контора «ZENBET»',
      rightString: 'Все права защищены',
    },
    mx: {
      siteTitle: "Apuesta deportiva | «ZENBET»",
      btnLogin: "INICIAR SESIÓN",
      btnSignup: "REGISTRAR",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Pruebesu suerte
          con «ZENBET» Bookmaker`
        : `Pruebe
          su suerte
          con «ZENBET» Bookmaker`),
      stepTitle1: "Registrar",
      stepSubtitle1: "Cree una cuenta en unos minutos.",
      stepTitle2: "Hacer depósitos",
      stepSubtitle2: "Haga un depósito utilizando cualquier método disponible.",
      stepTitle3: "Gane",
      stepSubtitle3: "Elija los eventos, haga sus apuestas ¡y gane!",
      productTitle1: "Apuesta deportiva",
      productDescription1: `Apuesta en deportes,  
        deportes electrónicos y más`,
      productTitle2: "Casino",
      productDescription2: `Pruebe su suerte
        en los juegos de casino y los tragamonedas`,
      productTitle3: "Casino en vivo",
      productDescription3: `Juegue en línea
        con dealers reales`,
      productTitle4: "Betgames",
      productDescription4: `Haga apuestas en
        juegos virtuales`,
      productTitle5: "Toto",
      productDescription5: `Adivine todos los resultados
        y gane el premio mayor`,
      bkString: '«ZENBET» Bookmakers',
      rightString: 'Todos los derechos reservados',
    },
    ru: {
      siteTitle: "Ставки на спорт | БК Зенит",
      btnLogin: "Войти",
      btnSignup: "Зарегистрироваться",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Испытай свою удачу
          в БК «ZENBET»`
        : `Испытай
          свою удачу
          в БК «ZENBET»`),
      stepTitle1: "Зарегистрируйся",
      stepSubtitle1: "Создай аккаунт всего за несколько минут.",
      stepTitle2: "Пополни счет",
      stepSubtitle2: "Внеси средства на баланс любым удобным способом.",
      stepTitle3: "Побеждай",
      stepSubtitle3: "Выбирай игры, делай ставки и выигрывай!",
      productTitle1: "Ставки на спорт",
      productDescription1: `Ставь на спорт, киберспорт
        или другие события`,
      productTitle2: "Казино",
      productDescription2: `Испытай удачу 
        в играх казино и слотах`,
      productTitle3: "Лайв-казино",
      productDescription3: `Играй онлайн 
        с живыми дилерами`,
      productTitle4: "Betgames",
      productDescription4: `Делай ставки на события
        в виртуальных играх`,
      productTitle5: "Тотализатор",
      productDescription5: `Угадай все исходы
        и сорви джекпот`,
      bkString: 'Букмекерская контора «ZENBET»',
      rightString: 'Все права защищены',
    },
    sw: {
      siteTitle: "Kuwekeza dau za michezo | «ZENBET»",
      btnLogin: "WEKA JINA LA MTUMIAJI",
      btnSignup: "JISAJILI",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Jaribu bahati yako
          na Alamisho «ZENBET»`
        : `Jaribu
          bahati yako
          na Alamisho «ZENBET»`),
      stepTitle1: "Jisajili",
      stepSubtitle1: "Fanyiza akaunti kwa dakika chache.",
      stepTitle2: "Weka pesa",
      stepSubtitle2: "Weka pesa kupitia njia yoyote inayopatikana.",
      stepTitle3: "Shida",
      stepSubtitle3: "Chagua matukio, wekeza dau na ushinde!",
      productTitle1: "Kuwekeza dau za michezo",
      productDescription1: `Wekeza dau za michezo, esports
        na nyinginezo`,
      productTitle2: "Kasino",
      productDescription2: `Jaribu bahati yako
        kwenye michezo ya kasino na vitengo`,
      productTitle3: "Kasino ya moja kwa moja",
      productDescription3: `Cheza mtandaoni
        na wachezaji halisi`,
      productTitle4: "Betgames",
      productDescription4: `Wekeza dau kwa
        michezo ya mitandaoni`,
      productTitle5: "Toto",
      productDescription5: `Bashiri matokeo yote
        na upate ushindi mkuu`,
      bkString: 'Alamisho «ZENBET»',
      rightString: 'Haki zote zimehifadhiwa',
    },
    tr: {
      siteTitle: "Spor bahisleri | «ZENBET»",
      btnLogin: "OTURUM AÇ",
      btnSignup: "KAYDOLUN",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `«ZENBET» Bahis Şirketi ile
          şansınızı deneyin`
        : `Zenit Bahis Şirketi 
          ile şansınızı deneyin`),
      stepTitle1: "Kaydolun",
      stepSubtitle1: "Birkaç dakika içinde bir hesap oluşturun.",
      stepTitle2: "Para yatırın",
      stepSubtitle2: "Herhangi bir yöntemi kullanarak para yatırın.",
      stepTitle3: "Galibiyet",
      stepSubtitle3: "Etkinlikleri seçin, bahis oynayın ve kazanın!",
      productTitle1: "Spor bahisleri",
      productDescription1: `Spor, e-spor ve daha 
        fazlası için bahis oynayın`,
      productTitle2: "Gazino",
      productDescription2: `Kumarhane oyunlarında
        ve slot makinelerinde şansınızı deneyin`,
      productTitle3: "Canlı kumarhane",
      productDescription3: `Gerçek krupiyelerle
        çevrimiçi oynayın`,
      productTitle4: "Betgames",
      productDescription4: `Sanal oyunlara
        bahis oynayın`,
      productTitle5: "Toto",
      productDescription5: `Tüm sonuçları tahmin
        edin ve turnayı gözünden vurun`,
      bkString: '«ZENBET» Bahis Şirketi',
      rightString: 'Tüm hakları saklıdır',
    },
    uz: {
      siteTitle: "Sportga stavkalar | «ZENBET» bukmekerlik kontorasi",
      btnLogin: "KIRISH",
      btnSignup: "RO‘YXATDAN O‘T",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `«ZENBET» BK da 
          o‘z omadingni sinab ko‘r`
        : `«ZENBET» BK da 
          o‘z omadingni
          sinab ko‘r`),
      stepTitle1: "Ro‘yxatdan o‘t",
      stepSubtitle1: "Atigi bir necha daqiqa ichida akkaunt yarat.",
      stepTitle2: "Hisobni to‘ldir",
      stepSubtitle2: "Balansga mablag‘larni istalgan usul bilan kirit.",
      stepTitle3: "G‘alaba qil",
      stepSubtitle3: "O‘yinlarni yut, stavkalar qil va yutib ol!",
      productTitle1: "Sportga stavkalar",
      productDescription1: `Sport, kibersport
        yoki boshqa hodisaga tik`,
      productTitle2: "Kazino",
      productDescription2: `Kazino o‘yinlari va slotlarda
        omadingni sinab ko‘r`,
      productTitle3: "Layv-kazino",
      productDescription3: `Jonli dilerlar bilan
        onlayn o‘yna`,
      productTitle4: "Betgames",
      productDescription4: `Virtual o‘yinlarda 
        hodisalarga stavkalar qil`,
      productTitle5: "Totalizator",
      productDescription5: `Barcha natijalarni to‘g‘ri 
        top va jekpotni yutib ol`,
      bkString: '«ZENBET» bukmekerlik kontorasi',
      rightString: 'Barcha huquqlar himoya qilinadi',
    },
    vi: {
      siteTitle: "Cá cược thể thao | «ZENBET»",
      btnLogin: "ĐĂNG NHẬP",
      btnSignup: "ĐĂNG KÝ",
      title: !IS_SERVER && (window.innerWidth > 550
        ? `Thử vận may của bạn
          với nhà cái «ZENBET»`
        : `Thử
          vận may của bạn
          với nhà cái «ZENBET»`),
      stepTitle1: "Đăng ký",
      stepSubtitle1: "Tạo tài khoản trong một vài phút.",
      stepTitle2: "Nạp tiền",
      stepSubtitle2: "Nạp tiền bằng bất kỳ phương thức nào có sẵn.",
      stepTitle3: "Chiến thắng",
      stepSubtitle3: "Chọn sự kiện, đặt cược và giành chiến thắng!",
      productTitle1: "Cá cược thể thao",
      productDescription1: `Đặt cược vào thể thao,  
        thể thao điện tử và hơn thế nữa`,
      productTitle2: "Casino",
      productDescription2: `Thử vận may của bạn tại 
        các trò chơi casino và máy đánh bạc`,
      productTitle3: "Casino trực tuyến",
      productDescription3: `Chơi trực tuyến với
        những người chia bài thực`,
      productTitle4: "Betgames",
      productDescription4: `Đặt cược vào các
        trò chơi trực tuyến`,
      productTitle5: "Toto",
      productDescription5: `Đoán tất cả các kết quả
        và trúng giải độc đắc`,
      bkString: 'Nhà cái «ZENBET»',
      rightString: ' Bảo lưu mọi quyền',
    }
  }
}
